import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { setSuccess } from "../../../Redux/AlertReducer";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";

export const FormEditAdSubCategory = ({ data, setData }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [isCategoryLoading, setIsCategoryLoading] = useState(false);
  const [categories, setCategories] = useState([]);

  const getData = async () => {
    setIsCategoryLoading(true);
    const { result, response } = await Helper.Get({
      url: `${api_Routes.AdCategories.GetAll}`,
    });
    if (response) {
      setCategories(response?.data);
    }
    setIsCategoryLoading(false);
  };

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoadingSubmit(true);

    const formDataToSend = new FormData();

    for (let key in data) {
      if (data[key] !== null) {
        formDataToSend.append(key, data[key]);
      }
    }

    try {
      const { result, response, message } = await Helper.Post({
        url: api_Routes.AdSubCategories.Edit + "/" + id,
        data: formDataToSend,
        isFormData: true,
      });

      setIsLoadingSubmit(false);
      if (response) {
        dispatch(setSuccess(true));
        navigate("/UserAds/AdSubCategories");
      }
    } catch (error) {
      console.error("An error occurred during form submission:", error);
      setIsLoadingSubmit(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <form onSubmit={handleSubmit}>
      <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-4">
        <TextField
          fullWidth
          margin="normal"
          label="Name"
          name="name"
          required
          type="name"
          autoComplete="off"
          value={data.name}
          onChange={handleInputChange}
          variant="outlined"
        />
        <TextField
          fullWidth
          margin="normal"
          label="Description"
          name="description"
          type="text"
          autoComplete="off"
          value={data.description}
          onChange={handleInputChange}
          variant="outlined"
        />
        <FormControl component="fieldset">
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <FormLabel component="legend">Active</FormLabel>
            <RadioGroup
              name="is_active"
              value={data.is_active}
              onChange={handleInputChange}
              row
            >
              <FormControlLabel value={"1"} control={<Radio />} label="Yes" />
              <FormControlLabel value={"0"} control={<Radio />} label="No" />
            </RadioGroup>
          </Box>
        </FormControl>
        <Autocomplete
          disablePortal
          loading={isCategoryLoading}
          options={categories}
          getOptionLabel={(option) => option.name || ""}
          onChange={(event, selectedOption) => {
            // Handle category selection
            setData((prev) => ({
              ...prev,
              ad_category_id: selectedOption?.id || "",
            }));
          }}
          value={
            categories.find((cat) => cat.id === data.ad_category_id) || null
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label="Category"
              variant="outlined"
              required
            />
          )}
        />
      </div>

      <Button
        type="submit"
        fullWidth
        variant="contained"
        disabled={isLoadingSubmit}
        color="primary"
        sx={{
          display: isLoadingSubmit ? "flex" : "block",
          marginTop: 2,
          width: "20%",
          marginX: "auto",
          fontWeight: "bold",
          justifyContent: "center",
        }}
      >
        {isLoadingSubmit ? (
          <CircularProgress size={24} color="primary" />
        ) : (
          "Submit"
        )}
      </Button>
    </form>
  );
};
